module.exports = __webpack_public_path__ + "img/快充面.6f382537.png";